import availTimes from './availTimes';
import isDebitware from './isDebitware';

/**
 * Get item price after tax, after discounts
 * @param {object} pkg item
 * @param {object} sale sale
 * @param {string} time optional time to get price for, if not supplied, sale's time will be used, and if sale has no time then non-time-specific price will be used
 * @param {boolean} checkDebitware optional flag to determine whether or not to return Debitware price or total price
 */
export const packagePrice = (
  pkg,
  sale,
  time = null,
  checkDebitware = false
) => {
  const { hasTimePrice, timePrice } = getTimePrice(pkg, sale, time);

  if (hasTimePrice) {
    return timePrice['prop-ext'];
  }

  if (checkDebitware && isDebitware(pkg)) {
    return pkg.dw_prel || pkg.price_object.root['prop-dwp_ext'] || 0;
  }

  return (pkg.price_list || [])[0] || 0;
};

/**
 * Get item post-tax initial price before discounts
 * @param {object} pkg item
 */
export const packageInitialPrice = pkg => {
  let initialPrice = pkg.price_object.root['prop-in'] || null;
  if (initialPrice == null || initialPrice.trim() === '') return null;

  initialPrice = parseFloat(initialPrice);
  return initialPrice;
};

/**
 * Get item's tax amount
 * @param {object} pkg item
 * @param {object} sale sale
 * @param {string} time optional time to get item tax for, if not supplied, sale's time will be used, and if sale has no time then non-time-specific tax will be used
 */
export const packagePriceTax = (pkg, sale, time = null) => {
  const { hasTimePrice, timePrice } = getTimePrice(pkg, sale, time);

  if (hasTimePrice) {
    return timePrice['prop-tax'];
  }

  if (isDebitware(pkg)) {
    return 0;
  }

  return (pkg.price_list || [])[1] || 0;
};

/**
 * Get item's pre-tax price
 * @param {object} pkg item
 * @param {object} sale sale
 * @param {string} time optional time to get item pre-tax price for, if not supplied, sale's time will be used, and if sale has no time then non-time-specific pre-tax price will be used
 */
export const packagePricePreTax = (pkg, sale, time = null) => {
  const { hasTimePrice, timePrice } = getTimePrice(pkg, sale, time);

  if (hasTimePrice) {
    return timePrice['prop-ex2'];
  }

  return packagePrice(pkg, sale, time) - packagePriceTax(pkg, sale, time);
};

/**
 * Get item's time-specific price object for a given time or the time already in the sale
 * @param {object} pkg item
 * @param {object} sale sale
 * @param {string} time optional time to get item's time price object for, if not supplied, sale's time will be used
 */
function getTimePrice(pkg, sale, time = null) {
  time = time == null ? (sale.packages[pkg.item_id] || {}).time : time;
  if (time == null || time.trim() === '') {
    return { hasTimePrice: false, timePrice: {} };
  }
  const _availTimes = availTimes(pkg, sale);
  var timeObj = _availTimes[`prop-${time}`];
  const timePrice = timeObj['prop-price_xml'];
  const hasTimePrice =
    timePrice != null && timePrice != '' && typeof timePrice == 'object';
  return { hasTimePrice, timePrice };
}
